module.exports = __webpack_public_path__ + "static/img/27.70878c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/27.jpg
// module id = YRNY
// module chunks = 16